<template v-cloak>
  <div class="media-library__filters media-library__filters--desktop">
    <h5 class="media-library__filters-title">Filter</h5>

    <details class="filter-block" v-for="filterGroup in filters" :key="filterGroup.id" open>
      <summary>
        {{ filterGroup.title }}
        <svg aria-hidden="true" role="presentation" width="24" height="24" viewBox="0 0 24 24" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_1670_2867)">
            <path d="M16.59 8.59375L12 13.1737L7.41 8.59375L6 10.0037L12 16.0037L18 10.0037L16.59 8.59375Z"
                  fill="currentColor" />
          </g>
          <defs>
            <clipPath id="clip0_1670_2867">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </summary>
      <ul>
        <li v-for="filter in filterGroup.items" :key="filter.id" class="checkbox-small">
          <input
              type="checkbox"
              :id="`${filterGroup.id}-${filter.id}`"
              :checked="filter.isActive"
              @change="changeFilter(filter)"
          />
          <label :for="`${filterGroup.id}-${filter.id}`" v-html="filter.name" />
        </li>
      </ul>
    </details>
    <button
        class="btn btn--3"
        @click="clearFilters"
        v-if="activeFilters.length > 0 && resetLabel"
        v-html="resetLabel"
    />
  </div>
</template>

<script setup>
defineProps( {
  filters: {
    type: Array,
    required: true
  },
  activeFilters: {
    type: Array,
    default: () => [],
    required: false,
  },
  resetLabel: {
    type: String,
    default: 'Reset filters',
    required: false
  }
} );

const emit = defineEmits( [ 'filterChanged', 'clearFilters' ] );

const changeFilter = ( filter ) => emit( 'filterChanged', filter );
const clearFilters = () => emit( 'clearFilters' );
</script>
